import { useScriptMetaPixel, useScriptGoogleTagManager, useScript, defineNuxtPlugin } from '#imports'

export default defineNuxtPlugin({
  name: "scripts:init",
  env: { islands: false },
  parallel: true,
  setup() {
    const googleTagManager = useScriptGoogleTagManager({"id":"GTM-5H85BTW"})
    const metaPixel = useScriptMetaPixel({"id":"397670604352967"})
    return { provide: { $scripts: { googleTagManager, metaPixel } } }
  }
})